var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { Form, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { StyledButton } from 'components/Shared/StyledButton/StyledButton';
import { InputFieldType } from 'models/Input/InputModels';
import { PubInputField } from 'components/Shared/PubInputField/PubInputField';
import { searchParamsHelper } from 'components/ProductBuild/searchParamsHelper';
import { getUTCDateData } from 'components/ProductBuild/helper';
import { getParsedProduct } from 'services/api/parsed-product-search-service';
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import Typography from '@mui/material/Typography';
import { dateFormatHelper } from 'utils/date-format-helper';
import { ParsedProductSearchResults } from '../ParsedProductSearchResults/ParsedProductSearchResults';
import { createNavigationURL } from '../ParsedProductSearchForm/ParsedProductSearchForm';
import styles from './ParsedProductFormMulti.module.scss';
export function ParsedProductFormMulti() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f;
    var navigate = useNavigate();
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var searchParams = useSearchParams()[0];
    var urlParamsMemo = useMemo(function () {
        var _a, _b, _c, _d, _e;
        return ({
            text: (_a = searchParams.get('productNbr')) !== null && _a !== void 0 ? _a : '',
            date: (_b = searchParams.get('date')) !== null && _b !== void 0 ? _b : '',
            time: (_c = searchParams.get('time')) !== null && _c !== void 0 ? _c : '',
            rbv: (_d = searchParams.get('channel')) !== null && _d !== void 0 ? _d : '',
            parsedProductId: (_e = searchParams.get('parsedProductId')) !== null && _e !== void 0 ? _e : '',
        });
    }, [searchParams]);
    var buildParams = useMemo(function () {
        var _a;
        var textVal = (urlParamsMemo === null || urlParamsMemo === void 0 ? void 0 : urlParamsMemo.text) && (urlParamsMemo === null || urlParamsMemo === void 0 ? void 0 : urlParamsMemo.text) !== '' ? urlParamsMemo === null || urlParamsMemo === void 0 ? void 0 : urlParamsMemo.text : urlParamsMemo === null || urlParamsMemo === void 0 ? void 0 : urlParamsMemo.parsedProductId;
        var val = searchParamsHelper((_a = !urlParamsMemo.date) !== null && _a !== void 0 ? _a : true, textVal, urlParamsMemo);
        if ((urlParamsMemo === null || urlParamsMemo === void 0 ? void 0 : urlParamsMemo.text) === '') {
            val.text = '';
        }
        return val;
    }, [urlParamsMemo]);
    var _g = useState({
        text: buildParams.text,
        date: buildParams.date,
        displayDate: buildParams.displayDate,
        time: buildParams.time,
        displayTime: buildParams.displayTime,
        rbv: buildParams.rbv,
        parsedProductId: buildParams.parsedProductId,
    }), searchData = _g[0], setSearchData = _g[1];
    var location = useLocation();
    sessionStorage.setItem('rawMultiData', JSON.stringify(location.state));
    var dataVal = JSON.parse((_a = sessionStorage.getItem('rawMultiData')) !== null && _a !== void 0 ? _a : '');
    var _h = useState((_c = (_b = dataVal === null || dataVal === void 0 ? void 0 : dataVal.data) === null || _b === void 0 ? void 0 : _b.body) !== null && _c !== void 0 ? _c : []), rawDataToPass = _h[0], setRawDataToPass = _h[1];
    var _j = useState((_e = (_d = dataVal === null || dataVal === void 0 ? void 0 : dataVal.data) === null || _d === void 0 ? void 0 : _d.total) !== null && _e !== void 0 ? _e : []), totalCount = _j[0], setTotalCount = _j[1];
    var _k = useState(false), isLoading = _k[0], setIsLoading = _k[1];
    var handleSearchDataValueChange = function (field, val) {
        var data = __assign({}, searchData);
        data[field] = val;
        if (field === 'date') {
            data.date = getUTCDateData(val, data.displayTime).date;
            data.displayDate = val;
        }
        else if (field === 'time') {
            var _a = getUTCDateData(data.displayDate === ''
                ? dateFormatHelper.todaysDateFormattedLocale({ format: 'yyyy-MM-dd' })
                : data.displayDate, val), date = _a.date, time = _a.time;
            data.time = time;
            data.date = date;
            data.displayTime = val;
        }
        setSearchData(function () { return data; });
    };
    var disableButton = useMemo(function () {
        var isDisplayDateEmpty = searchData.displayDate === '';
        var isDisplayTimeEmpty = searchData.displayTime === '';
        if (isDisplayDateEmpty && isDisplayTimeEmpty && !searchData.parsedProductId && !searchData.text) {
            return true;
        }
        if (!isDisplayDateEmpty && isDisplayTimeEmpty && !searchData.parsedProductId && !searchData.text) {
            return true;
        }
        if (!isDisplayDateEmpty && !isDisplayTimeEmpty && !searchData.parsedProductId && !searchData.text) {
            return true;
        }
        if (isDisplayDateEmpty && !isDisplayTimeEmpty && !searchData.parsedProductId && !searchData.text) {
            return true;
        }
        if (!isDisplayDateEmpty && isDisplayTimeEmpty && searchData.parsedProductId && searchData.text) {
            return true;
        }
        if (isDisplayDateEmpty && !isDisplayTimeEmpty && searchData.parsedProductId && searchData.text) {
            return true;
        }
        if (!isDisplayDateEmpty && isDisplayTimeEmpty && searchData.parsedProductId && !searchData.text) {
            return true;
        }
        if (!isDisplayDateEmpty && isDisplayTimeEmpty && !searchData.parsedProductId && searchData.text) {
            return true;
        }
        if (isDisplayDateEmpty && !isDisplayTimeEmpty && searchData.parsedProductId && !searchData.text) {
            return true;
        }
        if (isDisplayDateEmpty && !isDisplayTimeEmpty && !searchData.parsedProductId && searchData.text) {
            return true;
        }
        return false;
    }, [searchData]);
    var handleSearchButtonClick = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var text, date, time, parsedProductId, parsedProductResult;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsLoading(true);
                    text = searchData.text, date = searchData.date, time = searchData.time, parsedProductId = searchData.parsedProductId;
                    return [4 /*yield*/, getParsedProduct(parsedProductId !== null && parsedProductId !== void 0 ? parsedProductId : '', text, date, time)];
                case 1:
                    parsedProductResult = _b.sent();
                    if (parsedProductResult.status >= 500) {
                        setIsLoading(false);
                        setSnackbarAlert({
                            message: 'Server Error - Please report the error to the PLS support board/help desk with details',
                            type: 'error',
                        });
                        return [2 /*return*/];
                    }
                    if (parsedProductResult.status === 200 && parsedProductResult.body) {
                        setRawDataToPass(parsedProductResult === null || parsedProductResult === void 0 ? void 0 : parsedProductResult.body);
                        setTotalCount((_a = parsedProductResult === null || parsedProductResult === void 0 ? void 0 : parsedProductResult.total) !== null && _a !== void 0 ? _a : 0);
                        navigate("/parsed-product/multi?".concat(createNavigationURL(text, date, time, parsedProductId !== null && parsedProductId !== void 0 ? parsedProductId : '')), {
                            state: { data: parsedProductResult },
                        });
                        setIsLoading(false);
                    }
                    else {
                        setTotalCount(0);
                        setIsLoading(false);
                        setRawDataToPass([]);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [searchData, navigate, setSnackbarAlert]);
    useEffect(function () {
        if (!dataVal) {
            handleSearchButtonClick();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsxs(Form, { children: [_jsxs(Box, __assign({ className: styles.form }, { children: [_jsx("h1", __assign({ className: styles.title }, { children: "Parsed Product" })), _jsx(Box, __assign({ className: styles.searchContainer, sx: { width: '350px' } }, { children: _jsx(PubInputField, { labels: { left: 'Parsed Product ID' }, fieldType: InputFieldType.NUMBER, fieldValue: (_f = searchData === null || searchData === void 0 ? void 0 : searchData.parsedProductId) !== null && _f !== void 0 ? _f : '', fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('parsedProductId', e); }, formInputName: "parsedProductId", dirtyCheck: true, borderFocus: !!searchData.parsedProductId && searchData.parsedProductId !== '' }) })), _jsx(Box, __assign({ className: styles.searchContainer, sx: { width: '350px' } }, { children: _jsx(PubInputField, { labels: { left: 'Full or Partial Product Number' }, fieldType: InputFieldType.STRING, fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.text, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('text', e); }, formInputName: "productNbr", validations: { noSpaces: 'Please avoid space' }, dirtyCheck: true, borderFocus: !!searchData.text && searchData.text !== '' }) })), _jsxs(Box, __assign({ className: styles.searchContainer }, { children: [_jsx(PubInputField, { labels: { left: 'Date' }, fieldType: InputFieldType.DATE, fieldValue: searchData.date ? searchData === null || searchData === void 0 ? void 0 : searchData.displayDate : '', fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('date', e); }, formInputName: "date", dirtyCheck: true, showErrorAdornment: false, borderFocus: !!searchData.date, fieldError: !!(searchData === null || searchData === void 0 ? void 0 : searchData.displayTime) && !(searchData === null || searchData === void 0 ? void 0 : searchData.displayDate) }), (searchData === null || searchData === void 0 ? void 0 : searchData.displayTime) && !(searchData === null || searchData === void 0 ? void 0 : searchData.displayDate) && (_jsx(Typography, __assign({ className: styles.errorMessage }, { children: "Date is required " })))] })), _jsxs(Box, __assign({ className: styles.searchContainer, sx: { width: '140px' } }, { children: [_jsx(PubInputField, { labels: { left: 'Time' }, fieldType: InputFieldType.TIME, fieldValue: searchData.time ? searchData === null || searchData === void 0 ? void 0 : searchData.displayTime : '', fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('time', e); }, formInputName: "time", dirtyCheck: true, showErrorAdornment: false, borderFocus: !!searchData.time, fieldError: !!(searchData === null || searchData === void 0 ? void 0 : searchData.displayDate) && !(searchData === null || searchData === void 0 ? void 0 : searchData.displayTime) }), (searchData === null || searchData === void 0 ? void 0 : searchData.displayDate) && !(searchData === null || searchData === void 0 ? void 0 : searchData.displayTime) && (_jsx(Typography, __assign({ className: styles.errorMessage }, { children: "Time is required" })))] })), _jsx(Box, __assign({ className: styles.buttonContainer }, { children: _jsx(StyledButton, { type: "submit", labelText: "Search", height: "35px", disabled: disableButton, buttonAction: function () { return handleSearchButtonClick(); } }) }))] })), _jsx("hr", { className: styles.hr }), !isLoading ? (_jsx(ParsedProductSearchResults, { rawTableData: rawDataToPass, totalCount: totalCount })) : (_jsx(LoadingSpinner, { indicatorSize: 10 }))] }));
}
